import React from "react";

const ExperienceItem = ({ experience, isLast, revealIndex = 0 }) => (
  <article
    className="experience-card-v2"
    data-scroll-reveal="timeline"
    style={{ "--reveal-delay": `${0.1 + revealIndex * 0.12}s` }}
  >
    <div className="experience-card-marker" aria-hidden="true">
      <span className="experience-dot" />
      {!isLast && <span className="experience-line" />}
    </div>
    <div className="experience-card-body">
      <span className="experience-period">{experience.period}</span>
      <h3>{experience.title}</h3>
      <p className="experience-company">
        <i className="fas fa-building" aria-hidden="true"></i>
        {experience.company}
      </p>
      <p className="experience-desc">{experience.description}</p>
    </div>
  </article>
);

export default ExperienceItem;
